import React, { Fragment, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import SendMessageModal from "../modals/SendMessageModal";
import { PageTitleController } from "../components/PageTitleController";
import { BsSendFill } from "react-icons/bs";
import { MessageTable } from "../components/MessageTable";
import { useAuth } from "../context/AuthContext";
import { Container } from "react-bootstrap";
import MessageTypeSelection from "../components/MessageTypeSelection";
import DropDownFetchCount from "../components/DropDownFetchCount";

const MyMessages = () => {
  const { authAxios } = useAuth();
  const [showSendMessage, setShowSendMessage] = useState(false);
  const [user, setUser] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [fetchCount, setFetchCount] = useState(25);
  const [type, setType] = useState(null);

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const response = await authAxios().get(
        "/api/backoffice/users/current_user",
        config,
      );

      setUser(response.data);
    } catch (error) {
      console.log("Error catch");
      console.log(error);
    }
  };

  const toggleRefresh = () => {
    setRefresh(!refresh);
  };

  return (
    <Fragment>
      <Row>
        <PageTitleController
          title={"My Messages"}
          icon={<BsSendFill className={"icon-right-spacing"} />}
        />
        <Col>
          <Row xs={"auto"} className={"justify-content-end"}>
            <Button variant="offblack" onClick={() => setShowSendMessage(true)}>
              + New Message
            </Button>
          </Row>
        </Col>
      </Row>

      <Container fluid className={"p-0 m-0"}>
        <Row xs={"auto"} className={"align-items-center g-3"}>
          <Col xs={"auto"}>
            <MessageTypeSelection 
              onSelected={setType} 
              placeholderText="Select Message Type"
            />
          </Col>
          <Col xs={"auto"}>
            <DropDownFetchCount
              onSelected={setFetchCount}
              defaultSelection={fetchCount}
            />
          </Col>
        </Row>
      </Container>

      <br />
      {user ? (
        <MessageTable
          selectedUser={user}
          selectedFetchCount={fetchCount}
          selectedType={type}
          refresh={refresh}
          markSeen={true}
        />
      ) : null}

      <SendMessageModal
        visible={showSendMessage}
        close={() => setShowSendMessage(false)}
        refresh={toggleRefresh}
      />
    </Fragment>
  );
};

export default MyMessages;
